export const CART_MODULE_ERRORS = [
    {
        // 同一菜品超过最大数量
        error: 'R1: Excessed the max quantity.',
        message: 'order_cart_page_text_same_dish_number_exceed'
    },
    {
        // 超过轮次最大点餐数量
        error: 'R3: Excessed the max quantity in per turn.',
        message: 'order_cart_page_text_round_max_number_exceed'
    },
    {
        // 您已完成本轮次点餐 （上轮次时间还没到）
        error: 'R3: The current turn has ended ordering.',
        message: 'order_cart_page_text_complete_order'
    },
    {
        // 超过同类菜品限制数量
        error: 'R8: Excessed the max quantity.',
        message: 'order_cart_page_text_similar_dish_number_exceed'
    },
    {
        // 最大点餐回合数
        error: 'R3: Excessed the max turn.',
        message: 'order_cart_page_text_max_rounds_exceed'
    },
    {
        // 提交购物车ws超时未返回结果
        error: 'TIME_OUT',
        message: 'order_cart_page_text_commit_cart_fail'
    },
    {
        // 超过最大回合数
        error:'R3: Excessed the max turn.',
        message:'order_cart_page_text_max_rounds_exceed'
    },
    {
        // 数量沽清菜品可用数量限制
        error:'R1: Excessed the max sell quantity.',
        message:'order_cart_page_text_dish_is_sold_out'
    },
]